<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">CAMBIO DE CONTRASEÑA</h1>
    </section>

    <form [formGroup]="passwordForm" (ngSubmit)="saveChanges(passwordForm.value)">
      <mat-card>
        <div fxLayout="column" fxLayoutAlign="space-evenly stretch">

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Contraseña Actual</mat-label>
              <input type="password" matInput formControlName="dsPassword">
              <mat-error *ngIf="passwordForm.controls['dsPassword'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Nueva Contraseña</mat-label>
              <input type="password" matInput formControlName="dsNewPassword">
              <mat-error *ngIf="passwordForm.controls['dsNewPassword'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['dsNewPassword'].hasError('cannotContainSpace')">
                La nueva contraseña no puede ser un espacio vacío.
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['dsNewPassword'].hasError('minlength')">
                La nueva contraseña debe tener al menos 8 caracteres.
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="outline">
              <mat-label>Repetir Nueva Contraseña</mat-label>
              <input type="password" matInput formControlName="confirmNew">
              <mat-error *ngIf="passwordForm.controls['confirmNew'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="passwordForm.controls['confirmNew'].hasError('passDistinta')">
                Las contraseñas no coinciden
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      </mat-card>
      <br>

      <div fxLayout="row" fxLayoutAlign="start center">

        <button type="submit" mat-raised-button class="save-changes" [disabled]="!passwordForm.valid">
          CONFIRMAR CAMBIOS
        </button>
        <button routerLink="/shop-home" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>